import axios from "./axios";

export async function checkCustomerNumber(payload) {
  return axios.get(`/customers/checkNumber`, {
    params: payload,
  });
}

export async function checkCustomerEmail(payload) {
  return axios.get(`/customers/checkEmail`, {
    params: payload,
  });
}

export async function getCustomerAgreements(customerId) {
  return axios
    .get(`/customers/${customerId}/agreements`)
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

export async function fetchCustomers(controller) {
  return axios({ method: "get", url: "/customers", params: controller })
    .then((response) => {
      return response.data;
    })
    .catch((error) => {
      return error.response.data;
    });
}

export async function fetchCustomer(id) {
  return axios.get(`/customers/` + id);
}

export async function createCustomer(payload) {
  const response = await axios.post(`/customers/`, { customer: payload });
  // Global axios interceptor resolves error.response — treat non-OK as failure
  if (response.status >= 400) {
    return Promise.reject(response.data ?? { message: response.statusText });
  }
  return response.data;
}

export async function updateCustomer(payload) {
  const response = await axios.put(`/customers/${payload.id}`, {
    customer: payload,
  });
  if (response.status >= 400) {
    return Promise.reject(response.data ?? { message: response.statusText });
  }
  return response.data;
}

export async function destroyCustomer(payload) {
  return axios
    .delete(`/customers/${payload.id}`, {
      data: JSON.stringify({
        payload,
      }),
    })
    .then((response) => {
      return response;
    })
    .catch((error) => {
      return error.response;
    });
}

export async function fetchCustomerContacts(controller) {
  return axios({ method: "get", url: "/contacts/", params: controller })
    .then((response) => response.data)
    .catch((error) => error.response?.data || {});
}

export async function fetchCustomerContact(id) {
  return axios.get(`/contacts/` + id);
}

export async function createCustomerContact(payload) {
  return axios
    .post(`/contacts`, { contact: payload })
    .then((response) => response.data)
    .catch((error) => error.response?.data || {});
}

export async function createCustomerCommunication(customerId, payload) {
  return axios
    .post(`/customers/${customerId}/communications`, { communication: payload })
    .then((response) => response.data)
    .catch((error) => error.response?.data || {});
}

export async function fetchCustomerCommunications(customerId, controller = {}) {
  return axios({
    method: "get",
    url: `/customers/${customerId}/communications`,
    params: controller,
  })
    .then((response) => response.data)
    .catch((error) => error.response?.data || {});
}

export async function updateCustomerCommunication(customerId, communicationId, payload) {
  return axios
    .put(`/customers/${customerId}/communications/${communicationId}`, { communication: payload })
    .then((response) => response.data)
    .catch((error) => error.response?.data || {});
}

export async function fetchCustomerEvents(customerId, controller = {}) {
  return axios({
    method: "get",
    url: `/customers/${customerId}/events`,
    params: controller,
  })
    .then((response) => response.data)
    .catch((error) => error.response?.data || {});
}

export async function fetchAllCommunications(controller = {}) {
  return axios({
    method: "get",
    url: "/communications",
    params: controller,
  })
    .then((response) => response.data)
    .catch((error) => error.response?.data || {});
}